import React, { Component } from 'react';
import { Switch, Route, Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as artistsActions from './store/actions/artistsActions'
import * as evenimentsActions from './store/actions/evenimentsActions'
import './App.css'

import HomeView from './components/views/HomeView'
import ArtistsView from './components/views/ArtistsView'
import EvenimentsView from './components/views/EvenimentsView'

class App extends Component {
    componentDidMount() {
        this.props.evenimentsActions.fetch()
        this.props.artistsActions.fetch()
    }

    render() {
        return (
            <div className="app">
                <div className="app-header">
                    <h1>Calendar</h1>
                    {/*<nav>
                        <Link to="/">Overview</Link>
                        <Link to="/artists">Artisti</Link>
                        <Link to="/evenimente">Evenimente</Link>
                    </nav>*/}
                </div>
                <div className="app-content">
                    <Switch>
                        <Route exact path="/" component={EvenimentsView} />
                        <Route exact path="/artists" component={ArtistsView} />
                        <Route exact path="/evenimente" component={HomeView} />
                    </Switch>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        artists: state.artists
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        artistsActions: bindActionCreators(artistsActions, dispatch),
        evenimentsActions: bindActionCreators(evenimentsActions, dispatch)
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(App))



// WEBPACK FOOTER //
// ./src/App.js